/**
 * 取消原因配置
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, showConfirm, XTabNav } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, InputNumber } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import CancelModal from './modal/CancelModal';
import model from '@/reducers/system/parameter/model';

class ApplyReason extends React.PureComponent {

    state = {
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
        tab: [
            { id: 1, label: '用户端' },
            { id: 2, label: '骑士端' },
        ],
        curTabID: 1,  // 默认显示的tab
    }

    componentDidMount() { 
    }
    _tabChangeHandle = e => {
       this.setState({ curTabID: e }, () => {
           this._searchHandle('useCache')
       });
    }
    // 新建申诉理由
    _createRule = () => {
        this.setState({
            currentOpenMode: 'CREAT',
        });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, curTabID } = this.state;
        this.searchCache = {
            systemType: curTabID == 1 ? 'USER_APP' : 'RIDER_APP',
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getlistCancelReasons(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }


    // 表格操作
    _tableAction = (item, tabletype, value) => {
        switch (tabletype) {
            case 'editor':
                this.setState({
                    currentOpenMode: 'EDITOR',
                    openModeParam: value,
                });
                break;
            case 'switch':
                http('/?cmd=com.xqxc.api.pig.mis.biz.platform.CancelReasonsMisService.updateCancelReasonsStatus', {//状态
                    id: item.id,
                    status: (value === false) ? 0 : 1,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this._searchHandle('useCache');
                }).catch((reject = {}) => {
                    message.error(reject.message);
                });
                break;
        }
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }



    // 打开弹窗（创建/编辑）
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'CREAT':
                return <CancelModal title='取消原因' curTabID={this.state.curTabID} visible={true} closeMode={this._closeMode} />;
            case 'EDITOR':
                return <CancelModal title='取消原因' curTabID={this.state.curTabID} visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this._searchHandle('useCache');// 重新渲染更新列表
        }
    }

    render() {
        const { listCancelReasons } = this.props;
        return (
            <KeepAlive id='6' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='新建取消原因' onClick={this._createRule} />
                    </div>
                    <TableContent curTabID={this.state.curTabID} renderData={listCancelReasons} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

ApplyReason.propTypes = {
    history: PropTypes.object, // 路由history对象
    getlistCancelReasons: PropTypes.func,//表格数据(action)
    listCancelReasons: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        listCancelReasons: state.parameter.listCancelReasons,
    };
};
export default connect(mapStateToProps, {...model.actions})(ApplyReason);
